const urlChecker = [
  {
    path: '/jobs/url-checker',
    name: 'jobs-url-checker-list',
    component: () => import(/* webpackChunkName: "JobsUrlChecker" */ '@/views/jobs/url-checker/list.vue'),
    meta: {
      layout: 'content',
      module: 'MGJ,vacancies',
    },
  },
]

export default urlChecker
